export default __webpack_public_path__ + "static/media/Amit_Karna (1).86fa1da5.png";